import * as React from "react";
import { useState, useEffect } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { FxmsData } from "../../fxms/datas/FxData";
/**
 * 에너지 비교 챠트
 *
 * 개발자 : 최선하.
 * 개발년월 : 2022.11.
 * @param {*} props
 * @returns
 */
export const FeEnergyCompChart = (props) => {
  const { engId, src } = props;
  const [eng, setEng] = useState({});
  const [options, setOptions] = useState({});
  const [colors, setColors] = useState(["#0bbbfc", "#aab1c1", "#ff7600"]);
  let predictedValue = 0; // 예측값
  let actualValue = 0; // 실제값

  useEffect(() => {
    if (engId) {
      const engList = FxmsData.getDatas("energy");
      if (engList) {
        for (const e of engList) {
          if (e.engId === engId) {
            setEng(e);
            getCompDatas(e);
            break;
          }
        }
      }
    }
  }, [engId]);

  async function getCompDatas(eng) {
    const uri = "fems/select_eng_prod__sum_date";
    const para = { engId: eng.engId };
    const res = await FxmsData.GET(uri, para);
    if (res.data.length > 0) {
      let lastData = res.data[res.data.length - 1];
      predictedValue = Number(lastData.expProdAmt.toFixed(0));
      actualValue = Number(lastData.prodAmt.toFixed(0));
    } else {
    }

    setOptions(getChartData());
  }

  const getChartData = () => {
    return {
      title: {
        text: "",
        align: "center",
      },

      legend: {
        verticalAlign: "bottom",
        align: "center",
        enabled: true,
        backgroundColor: "rgba(34,50,51,0.04)",
        itemStyle: {
          color: "white",
          fontSize: "20px",
          fontWeight: "bold",
        },
      },

      plotOptions: {
        series: {
          animation: true,
          dataLabels: {
            enabled: true,
            style: {
              color: "white",
              fontSize: "11px",
              fontWeight: "bold",
              textOutline: "1px 1px",
            },
          },
        },
      },

      xAxis: {
        lineWidth: 1,
        lineColor: "#a9b0c1",
        gridLineColor: "#666666",
        tickColor: "#666666",
      },

      yAxis: {
        title: {
          text: "",
        },
        lineWidth: 0,
        lineColor: "#666666",
        gridLineColor: "#666666",
      },

      chart: {
        backgroundColor: "#313131",
        borderWidth: 1,
        borderRadius: 0,
        borderColor: "#303030",
        plotBackgroundColor: "#303030",
        plotBorderWidth: 1,
        plotBorderColor: "#303030",
      },

      credits: {
        enabled: false,
      },

      series: [
        {
          showInLegend: true,
          name: "예측",
          data: [predictedValue],
          type: "column",
          lineWidth: 1,
          linkedTo: ":previous",
          color: colors[0],
          fillOpacity: 0.3,
          zIndex: 0,
        },
        {
          showInLegend: true,
          name: "실제",
          data: [actualValue],
          type: "column",
          lineWidth: 1,
          linkedTo: ":previous",
          color: colors[1],
          fillOpacity: 0.3,
          zIndex: 0,
        },
      ],
    };
  };

  return (
    <>
      <HighchartsReact
        containerProps={{
          style: { maxHeight: "350px", width: "95%" },
        }}
        highcharts={Highcharts}
        options={options}
      />
      <span className="name">
        <img src={src} />
        {eng.engName}
      </span>
    </>
  );
};
